/* Se estabece este estilo pata que no recarguela */ 
section[class="mb-5 bg-light"] {
  position: relative;
  aspect-ratio: 16/9;
}